'use client';

import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

const AuthorityClosing = () => {
  return (
    <section className="py-24 lg:py-32 bg-[#0A2540] text-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <div className="mb-16">
            <h2 className="text-4xl md:text-5xl font-bold font-headline mb-8 leading-tight">
              Recognition Through Evidence, Not Marketing Claims
            </h2>
            <p className="text-xl md:text-2xl font-body leading-relaxed text-white/90 mb-6">
              Organisations that develop the capability to lead continuous transformation at the pace AI evolves build sustainable competitive advantage. Those that do not struggle to move beyond pilots.
            </p>
            <p className="text-xl md:text-2xl font-body leading-relaxed text-white/90">
              AI Change Leaders defines what good looks like. We assess organisations against the AI Change Leader Standard, benchmark their maturity, and recognise those that meet the criteria—not through promises, but through evidence.
            </p>
          </div>

          <div className="mb-16 p-10 border-2 border-white/20 bg-white/5">
            <p className="text-2xl font-body leading-relaxed text-white/95 mb-4">
              Recognition is earned, not purchased.
            </p>
            <p className="text-lg font-body leading-relaxed text-white/80">
              We are an independent, practitioner-led body defining the emerging discipline of AI Change Leadership. Organisations engage through diagnostic assessment, not consulting pitches. Those that demonstrate maturity earn the AI Change Leader designation—a mark that signals credibility, stewardship, and readiness to scale. Implementation may be led by internal teams or partners—we sit above delivery.
            </p>
          </div>

          <div>
            <Link
              href="/ai-change-leadership-pillar-page"
              className="inline-flex items-center gap-2 px-8 py-4 border-2 border-white text-white font-semibold font-body text-lg hover:bg-white hover:text-[#0A2540] transition-all duration-300"
            >
              Explore the Standard
              <Icon name="ArrowRightIcon" size={20} variant="outline" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AuthorityClosing;